/**
 * About Page
 * Clean, minimal design using on record Color Bible
 */

import LegalPageLayout from '../components/LegalPageLayout'

export default function About() {
  return (
    <LegalPageLayout title="About on record">
      <div className="space-y-12" style={{ color: '#111111', lineHeight: '1.75' }}>
        {/* Mission */}
        <section>
          <p className="text-lg">
            on record is a platform dedicated to authentic, verified content sharing. We believe in the power of truth
            and transparency in social media, creating a space where every post is verifiable and trustworthy.
          </p>
        </section>

        {/* What We Do */}
        <section>
          <h2 className="text-3xl font-bold mb-6" style={{ color: '#0A2342' }}>
            What We Do
          </h2>
          <p className="mb-4">
            on record provides a unique social media experience built on three core principles:
          </p>
          <ul className="list-disc list-inside space-y-3 ml-4" style={{ color: '#6B7280' }}>
            <li>
              <strong className="font-semibold" style={{ color: '#111111' }}>Authenticity:</strong> Every post receives a unique on record Code for permanent verification and content authentication
            </li>
            <li>
              <strong className="font-semibold" style={{ color: '#111111' }}>Privacy:</strong> We collect only city-level location data, protecting your exact whereabouts while maintaining content credibility
            </li>
            <li>
              <strong className="font-semibold" style={{ color: '#111111' }}>Truth:</strong> Our platform prioritizes genuine content over viral misinformation, building trust in every interaction
            </li>
          </ul>
        </section>

        {/* on record Code System */}
        <section>
          <h2 className="text-3xl font-bold mb-6" style={{ color: '#0A2342' }}>
            on record Code System
          </h2>
          <p>
            Each post on on record is assigned a unique 12-digit on record Code. This code serves as a permanent,
            tamper-proof identifier that allows anyone to verify when and where content was created. It's our commitment
            to authenticity — every post is on record, forever.
          </p>
        </section>

        {/* Privacy-Enhanced Location */}
        <section>
          <h2 className="text-3xl font-bold mb-6" style={{ color: '#0A2342' }}>
            Privacy-Enhanced Location Tracking
          </h2>
          <p className="mb-4">
            Unlike other platforms, on record takes a privacy-first approach to location data:
          </p>
          <ul className="list-disc list-inside space-y-2 ml-4" style={{ color: '#6B7280' }}>
            <li>We never store your exact GPS coordinates</li>
            <li>Posts are tagged with city/country information only</li>
            <li>Location data is separated from user identity</li>
            <li>Engagement analytics show aggregated city data without personal identification</li>
          </ul>
        </section>

        {/* Our Vision */}
        <section>
          <h2 className="text-3xl font-bold mb-6" style={{ color: '#0A2342' }}>
            Our Vision
          </h2>
          <p>
            We envision a social media landscape where authenticity is the norm, not the exception. Where users can share
            their experiences with confidence that their content is protected, verifiable, and part of a permanent record.
            on record is building the future of trustworthy social media.
          </p>
        </section>

        {/* Features */}
        <section>
          <h2 className="text-3xl font-bold mb-6" style={{ color: '#0A2342' }}>
            Platform Features
          </h2>
          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <h3 className="text-lg font-semibold mb-2" style={{ color: '#0A2342' }}>
                Verified Posts
              </h3>
              <p style={{ color: '#6B7280' }}>
                Every post is timestamped and assigned a unique on record Code for lifetime verification
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-2" style={{ color: '#0A2342' }}>
                Privacy-Safe Sharing
              </h3>
              <p style={{ color: '#6B7280' }}>
                Share your moments without compromising your exact location or personal privacy
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-2" style={{ color: '#0A2342' }}>
                Content Authentication
              </h3>
              <p style={{ color: '#6B7280' }}>
                AI-powered content moderation and authenticity verification keep the platform safe and trustworthy
              </p>
            </div>
            <div>
              <h3 className="text-lg font-semibold mb-2" style={{ color: '#0A2342' }}>
                Community Trust
              </h3>
              <p style={{ color: '#6B7280' }}>
                Build connections based on authentic content and genuine interactions, not algorithms
              </p>
            </div>
          </div>
        </section>

        {/* Contact */}
        <section>
          <h2 className="text-3xl font-bold mb-6" style={{ color: '#0A2342' }}>
            Get in Touch
          </h2>
          <p className="mb-4">
            We'd love to hear from you. Whether you have questions, feedback, or just want to learn more about on record:
          </p>
          <div className="space-y-2" style={{ color: '#6B7280' }}>
            <p>Contact: <a href="mailto:contact@onrecord.live" style={{ color: '#FFD43B' }} className="hover:underline">contact@onrecord.live</a></p>
          </div>
        </section>

        {/* Join Us */}
        <section className="pt-8 border-t" style={{ borderColor: '#E0E4E7' }}>
          <div className="text-center">
            <h2 className="text-3xl font-bold mb-4" style={{ color: '#0A2342' }}>
              Join the Movement
            </h2>
            <p className="text-lg mb-6">
              Be part of the future of authentic social media. Every post matters. Every moment is on record.
            </p>
            <a
              href="/signup"
              className="inline-block px-8 py-3 rounded-full font-semibold text-white transition-opacity hover:opacity-90"
              style={{ backgroundColor: '#FFD43B' }}
            >
              Get Started
            </a>
          </div>
        </section>
      </div>
    </LegalPageLayout>
  )
}
